import { z } from 'zod';

export const organisationIdSchema = z.uuid();

export const requiredNameSchema = z.string().trim().min(1).max(120);

export const optionalEmailSchema = z.union([z.email().max(320), z.literal('')]);

export const positiveMinutesSchema = z.number().int().min(5).max(1440);

export const nonNegativeMinorAmountSchema = z.number().int().nonnegative().safe();

export function decimalToMinorUnits(value: string, fractionDigits: number): number {
  if (!Number.isInteger(fractionDigits) || fractionDigits < 0 || fractionDigits > 3) {
    throw new Error('Unsupported currency fraction digits');
  }
  const pattern = new RegExp(`^\\d+(?:\\.\\d{1,${Math.max(1, fractionDigits)}})?$`);
  if (!pattern.test(value) || (fractionDigits === 0 && value.includes('.'))) {
    throw new Error('Enter a valid non-negative amount');
  }
  const [whole, fraction = ''] = value.split('.');
  const scale = 10n ** BigInt(fractionDigits);
  const amount = BigInt(whole!) * scale + BigInt(fraction.padEnd(fractionDigits, '0') || '0');
  if (amount > 999_999_999_999n) throw new Error('Amount is too large');
  return Number(amount);
}
